/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Layout, Menu } from "antd";
import { Content } from "antd/lib/layout/layout";
import { useSize } from "ahooks";
import { getUser } from "metabase/selectors/user";
import { StateContext, StateProvider } from "./StateProvider";
import "../css/index.css";
import GaSidebar from "./GaSidebar";

const GaLayout = props => {
  const pathname = location.pathname;
  const isHideSidebar = pathname.includes("/ab/chart") ||
    window.location.pathname.startsWith("/ab/games-manage") ||
    pathname.includes("/ab/dashboard/");
  return (
    <StateProvider>
      <LayoutView {...props} isHideSidebar={isHideSidebar} />
    </StateProvider>
  );
};


const LayoutView = props => {
  const { user } = props;
  const { isOpenSubMenu } = useContext(StateContext);
  const isAB = location.pathname.startsWith("/ab");
  const showSidebar = !props.isHideSidebar && isAB;
  const role = user?.role
  const size = useSize(document.querySelector('body'));
  const isLargeScreen = size && size.width >= 1920
  const [ collapsed, setCollapsed ] = useState(true);

  useEffect(() => {
    if (isLargeScreen) {
      setCollapsed(false);
    }
  }, [isLargeScreen])

  const getMarginLeft = () => {
    if (!showSidebar) {
      return 0;
    }
    return collapsed ? 80 : 272;
  }
  return (
    <>
      <Layout
        hasSider
        className={`ga-layout h-full ${
          isOpenSubMenu ? "" : "ga-layout--hide-sub-menu"
        }`}
        style={{ backgroundColor: "#101318" }}
        key={role}
      >
        {showSidebar && (
          <GaSidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />
        )}
        <Layout>
          <Content
            id={"ga-layout__content"}
            className="h-full ga-layout__content"
            style={{ marginLeft: getMarginLeft() }}
          >
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

const mapStateToProps = state => {
  return {
    user: getUser(state),
  };
};

export default connect(mapStateToProps)(GaLayout);
